var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationsMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 870,
    viewBox: "0 0 421 870",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M405.4 656C407.388 656 409 657.612 409 659.6V676.4C409 678.388 407.388 680 405.4 680H388.6C386.612 680 385 678.388 385 676.4L385 659.6C385 657.612 386.612 656 388.6 656L405.4 656Z",
    fill: "url(#paint0_linear_1_5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.7124 671.712C41.1685 671.256 41.7871 671 42.4322 671H61.3664C62.8212 671 64.0006 669.821 64.0006 668.366V649.634C64.0006 648.179 62.8212 647 61.3664 647H42.6347C41.1799 647 40.0006 648.179 40.0006 649.634V668.151C40.0006 668.85 39.723 669.52 39.229 670.014L39.0143 670.228C38.5203 670.722 37.8503 671 37.1517 671H18.6341C17.1793 671 16 672.179 16 673.634V692.366C16 693.821 17.1793 695 18.6341 695H37.3658C38.8206 695 40 693.821 40 692.366V673.432C40 672.787 40.2562 672.169 40.7124 671.712Z",
    fill: "url(#paint1_linear_1_5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 340L22.2631 340C21.6629 340 21.0873 340.238 20.6628 340.663C20.2384 341.087 20 341.663 20 342.263L20 357C20 358.657 18.6569 360 17 360L3 360C1.34315 360 3.61433e-06 358.657 3.75918e-06 357L4.9831e-06 343C5.12795e-06 341.343 1.34315 340 3.00001 340L17.7364 340C18.3368 340 18.9125 339.762 19.337 339.337C19.7615 338.913 20 338.337 20 337.736L20 323C20 321.343 21.3432 320 23 320L77 320C78.6569 320 80 321.343 80 323L80 337C80 338.657 78.6569 340 77 340Z",
    fill: "url(#paint2_linear_1_5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 380C58.6569 380 60 378.657 60 377L60 363C60 361.343 58.6569 360 57 360L23 360C21.3431 360 20 361.343 20 363L20 377.736C20 378.337 19.7615 378.913 19.337 379.337C18.9125 379.762 18.3368 380 17.7364 380L3 380C1.34315 380 1.63103e-06 381.343 1.48619e-06 383L2.62268e-07 397C1.17422e-07 398.657 1.34315 400 3 400L17 400C18.6569 400 20 398.657 20 397L20 382.263C20 381.663 20.2384 381.087 20.6628 380.663C21.0872 380.238 21.6629 380 22.2631 380L57 380Z",
    fill: "url(#paint3_linear_1_5)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.4 105C78.3882 105 80 106.612 80 108.6V125.4C80 127.388 78.3882 129 76.4 129H50.4466C49.4918 129 48.5761 129.379 47.901 130.054L47.4544 130.501C46.7793 131.176 46.4 132.092 46.4 133.047V148.363C46.4 149.318 46.7793 150.234 47.4544 150.909L48.4912 151.946C49.1663 152.621 50.082 153 51.0368 153H76.4C78.3882 153 80 154.612 80 156.6V173.4C80 175.388 78.3882 177 76.4 177H50C48.0118 177 46.4 175.388 46.4 173.4V156.321C46.4 155.44 46.0501 154.596 45.4272 153.973C44.8043 153.35 43.9595 153 43.0787 153H11.6C9.61178 153 8 151.388 8 149.4V132.6C8 130.612 9.61178 129 11.6 129L42.373 129C43.3278 129 44.2435 128.621 44.9186 127.946L45.3456 127.519C46.0207 126.844 46.4 125.928 46.4 124.973V108.6C46.4 106.612 48.0118 105 50 105H76.4Z",
    fill: "url(#paint4_linear_1_5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.244 25.8095C395.793 26.3583 396.538 26.6667 397.314 26.6667H418.073C419.689 26.6667 420.999 27.9771 420.999 29.5935V50.4065C420.999 52.023 419.689 53.3334 418.073 53.3334L397.036 53.3333C396.319 53.3333 395.632 53.618 395.125 54.1248C394.619 54.6316 394.334 55.3189 394.334 56.0356V77.0732C394.334 78.6896 393.024 80 391.407 80H370.594C368.978 80 367.667 78.6896 367.667 77.0732V56.3143C367.667 55.538 367.359 54.7936 366.81 54.2447L366.756 54.1906C366.207 53.6417 365.463 53.3333 364.686 53.3333H343.927C342.31 53.3333 341 52.023 341 50.4065V29.5935C341 27.9771 342.31 26.6667 343.927 26.6667H364.502C365.278 26.6667 366.023 26.3583 366.571 25.8094L366.81 25.5708C367.359 25.0219 367.667 24.2775 367.667 23.5012V2.92683C367.667 1.31038 368.978 0 370.594 0H391.407C393.024 0 394.334 1.31039 394.334 2.92683V23.6867C394.334 24.463 394.642 25.2074 395.191 25.7563L395.244 25.8095ZM393.423 27.5239C392.874 26.975 392.13 26.6667 391.354 26.6667H370.369C369.652 26.6667 368.965 26.9514 368.458 27.4582C367.951 27.965 367.667 28.6524 367.667 29.3691V50.3534C367.667 51.1297 367.975 51.8741 368.524 52.423L368.577 52.4761C369.126 53.025 369.87 53.3333 370.647 53.3333L391.169 53.3334C391.945 53.3334 392.69 53.025 393.239 52.4761L393.475 52.2392C394.024 51.6904 394.333 50.9459 394.333 50.1697V29.6456C394.333 28.8694 394.024 28.1249 393.475 27.5761L393.423 27.5239Z",
    fill: "url(#paint5_linear_1_5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.068 797.341C346.646 797.763 346.074 798 345.477 798L278.25 798C277.007 798 276 799.007 276 800.25L276 819.75C276 820.992 277.007 822 278.25 822L345.31 822C345.907 822 346.479 822.237 346.901 822.659L347.341 823.098C347.763 823.52 348 824.093 348 824.689L348 843.478C348 844.074 347.763 844.647 347.341 845.069L347.069 845.341C346.647 845.763 346.074 846 345.478 846L326.25 846C325.008 846 324 847.007 324 848.25L324 867.75C324 868.993 325.008 870 326.25 870L345.75 870C346.993 870 348 868.993 348 867.75L348 848.524C348 847.927 348.237 847.355 348.659 846.933L348.933 846.659C349.355 846.237 349.927 846 350.524 846L369.75 846C370.993 846 372 844.993 372 843.75L372 824.524C372 823.927 372.237 823.355 372.659 822.933L372.933 822.659C373.355 822.237 373.927 822 374.524 822L393.75 822C394.993 822 396 820.993 396 819.75L396 800.25C396 799.008 394.993 798 393.75 798L374.357 798C373.76 798 373.188 797.763 372.766 797.341L372.659 797.234C372.237 796.812 372 796.24 372 795.643L372 776.25C372 775.007 370.992 774 369.75 774L350.356 774C349.76 774 349.187 773.763 348.765 773.341L348.659 773.235C348.237 772.813 348 772.24 348 771.644L348 752.251C348 751.008 346.993 750.001 345.75 750.001L326.25 750.001C325.008 750.001 324 751.008 324 752.251L324 771.75C324 772.993 325.008 774 326.25 774L345.311 774C345.908 774 346.48 774.237 346.902 774.659L347.341 775.098C347.763 775.52 348 776.092 348 776.689L348 795.477C348 796.074 347.763 796.646 347.341 797.068L347.068 797.341ZM348.659 798.932C348.237 799.354 348 799.927 348 800.523L348 819.643C348 820.24 348.237 820.812 348.659 821.234L348.766 821.341C349.188 821.763 349.76 822 350.357 822L369.478 822C370.074 822 370.647 821.763 371.069 821.341L371.341 821.069C371.763 820.647 372 820.074 372 819.478L372 800.69C372 800.093 371.763 799.521 371.341 799.099L370.901 798.659C370.479 798.237 369.907 798 369.31 798L350.523 798C349.926 798 349.354 798.237 348.932 798.659L348.659 798.932Z",
    fill: "url(#paint6_linear_1_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5",
    x1: 397,
    y1: 656,
    x2: 397,
    y2: 680,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5",
    x1: 40.0003,
    y1: 647,
    x2: 40.0003,
    y2: 695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5",
    x1: 40,
    y1: 400,
    x2: 40,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_5",
    x1: 40,
    y1: 400,
    x2: 40,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_5",
    x1: 44,
    y1: 105,
    x2: 44,
    y2: 177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_5",
    x1: 381,
    y1: -0.00000665783,
    x2: 381,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_5",
    x1: 276,
    y1: 810,
    x2: 396,
    y2: 810,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsMob);
export default __webpack_public_path__ + "static/media/locationsMob.467f5733ae39682cbb0abea3ff4cb157.svg";
export { ForwardRef as ReactComponent };